import {useMemo} from 'react'
import {useReviews} from './use-reviews'

export function useCommentReviews() {
  const reviewSummaries = useReviews()

  return useMemo(() => reviewSummaries.filter(reviewSummary => reviewSummary.state === 'COMMENTED'), [reviewSummaries])
}
